export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=3f95dcc2&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/materials/materials-white-label/id/index.vue?vue&type=template&id=3f95dcc2&
// module id = 1518
// module chunks = 0